/**
 * Header language dropdown (multisite).
 */
let lastLanguageToggle = null;

function setLanguageExpanded(isOpen) {
	document.querySelectorAll('[data-site-language-toggle]').forEach((el) => {
		el.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
	});
}

export function closeLanguage() {
	const panel = document.querySelector('[data-site-language]');
	if (!panel || !document.body.classList.contains('site-language-open')) {
		return;
	}

	const toggle = lastLanguageToggle || document.querySelector('[data-site-language-toggle]');
	const icon = toggle?.querySelector('[data-site-language-icon]');

	panel.classList.add('opacity-0', 'pointer-events-none', 'translate-y-1');
	panel.classList.remove('opacity-100', 'pointer-events-auto', 'translate-y-0');
	panel.setAttribute('aria-hidden', 'true');
	document.body.classList.remove('site-language-open');
	setLanguageExpanded(false);
	toggle?.classList.remove('bg-light-gray');
	icon?.classList.remove('rotate-180');

	if (lastLanguageToggle instanceof HTMLElement) {
		lastLanguageToggle.focus();
		lastLanguageToggle = null;
	}
}

function openLanguage(triggerEl) {
	const panel = document.querySelector('[data-site-language]');
	if (!panel || document.body.classList.contains('site-language-open')) {
		return;
	}

	if (triggerEl instanceof HTMLElement) {
		lastLanguageToggle = triggerEl;
	}

	const icon = triggerEl.querySelector('[data-site-language-icon]');

	panel.classList.remove('opacity-0', 'pointer-events-none', 'translate-y-1');
	panel.classList.add('opacity-100', 'pointer-events-auto', 'translate-y-0');
	panel.setAttribute('aria-hidden', 'false');
	document.body.classList.add('site-language-open');
	setLanguageExpanded(true);
	triggerEl.classList.add('bg-light-gray');
	icon?.classList.add('rotate-180');
}

document.querySelectorAll('[data-site-language-toggle]').forEach((btn) => {
	btn.addEventListener('click', (e) => {
		e.stopPropagation();

		if (document.body.classList.contains('site-language-open')) {
			closeLanguage();
		} else {
			openLanguage(btn);
		}
	});
});

document.addEventListener('click', (e) => {
	const wrapper = document.querySelector('[data-site-language-wrapper]');
	if (!document.body.classList.contains('site-language-open')) {
		return;
	}

	if (!wrapper?.contains(e.target)) {
		closeLanguage();
	}
});

document.addEventListener('keydown', (e) => {
	if (e.key === 'Escape' && document.body.classList.contains('site-language-open')) {
		closeLanguage();
	}
});
